export default __webpack_public_path__ + "static/media/nik-fahl-vector.3700a4ac.svg";